import { useCallback } from 'react'
import useLogout from 'hooks/useLogout'

function LogOutButton({ children }: { children?: React.ReactNode }) {
  const logout = useLogout()
  const signOut = useCallback(async () => {
    await logout()
  }, [logout])

  return (
    <button className="button ob-button is-primary" onClick={signOut}>
      {children || 'Log Out'}
    </button>
  )
}

export default LogOutButton
